'use strict';

import {debounce} from '../../utils/debounce';

const classNames = {
	horizontalNav: 'horizontal-primary-nav',
	item: 'item',
	link: 'item__link',
	menu: 'menu',
	moreMenu: 'more-menu',
	moreMenuContent: 'more-menu__content',
	siteHeader: 'site-header-full',
	subNav: 'sub-nav',
	subNavItem: 'sub-nav__item',
	subNavLink: 'sub-nav__item__link'
};

function setupMoreMenu() {
	let $horizontalNav = $.findByBem(classNames.horizontalNav);
	let $moreMenu = $horizontalNav.findByBem(classNames.horizontalNav, classNames.moreMenu);
	let $moreMenuContent = $moreMenu.findByBem(classNames.horizontalNav, classNames.moreMenuContent);

	$moreMenuContent.html('').addClass('hide');
	let menuTop = $horizontalNav.findByBem(classNames.horizontalNav, classNames.menu).offset().top;
	let menuDisplayedWidth = 0;

	let $primaryNavItems = $horizontalNav.findByBem(classNames.horizontalNav, classNames.item);
	$primaryNavItems.each(function () {
		let $element = $(this);
		let $link = $element.childrenByBem(classNames.horizontalNav, classNames.link);
		let $subNav = $element.childrenByBem(classNames.horizontalNav, classNames.subNav);

		if ($element.offset().top > menuTop) {
			let $overflowElement = $('<li></li>');
			$overflowElement.addBemClass(classNames.horizontalNav, classNames.subNavItem);

			let $overflowLink = $link.clone()
				.removeBemClass(classNames.horizontalNav, classNames.link)
				.addBemClass(classNames.horizontalNav, classNames.subNavLink);

			$overflowElement.append($overflowLink);

			if ($subNav.length > 0) {
				$overflowElement.append($subNav.clone().removeClass('hide'));
			}

			$moreMenuContent.append($overflowElement);
		} else {
			// Add a pixel for right border
			menuDisplayedWidth += $(this).width() + 1;
		}
	});

	if ($moreMenuContent.html()) {
		$moreMenu.css('left', menuDisplayedWidth);
		$moreMenu.css('visibility', 'visible');
	}

	// If already initialised, re-init for sub menus. If not, this will be done after foundation finishes
	if ($moreMenu.is('[data-t]')) {
		$moreMenu.foundation('_init');
		$moreMenuContent.removeClass('hide');
	}
}

let onWindowResize = debounce(setupMoreMenu, 100);

export default {
	init: function () {
		setupMoreMenu();

		// Sub-navs are hidden to stop menu items jumping when loaded.
		// Remove that class the first time they should be displayed to let foundation run things from there
		let $subNavs = $.findByBem(classNames.horizontalNav, classNames.subNav);
		$(document).on('show.zf.dropdownMenu', function () {
			$subNavs.removeClass('hide');
			$(document).off('show.zf.dropdownMenu');
		});

		let $moreMenu = $.findByBem(classNames.horizontalNav, classNames.moreMenu);
		$(window).on('resize.horizontal-nav', function () {
			$moreMenu.css('visibility', 'hidden');
			onWindowResize();
		});
	}
}